import React, { useEffect, useState } from 'react';
import * as PR from "../../prime-modules/index";
import { updateCustomerName } from '../../services/api';

function NameModal({ setNameModal, nameModal, userId, toast, headers, dispatch,rowData,page,updateData }) {
  const [errors, setErrors] = useState({ firstName: "", lastName: "" });
  const [firstName, setFirstName] = useState(rowData?.firstName || '');
  const [lastName, setLastName] = useState(rowData?.lastName ||'');
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    setFirstName(rowData?.firstName )
    setLastName(rowData?.lastName )
  }, [rowData?.firstName, rowData?.lastName, userId])
  

  const validateForm = () => {
    let valid = true;
    let newErrors = { firstName: "", lastName: "" };

    if (!firstName.trim()) {
      newErrors.firstName = "First name is required.";
      valid = false;
    } else if (firstName.trim().length < 3 || firstName.trim().length > 20) {
      newErrors.firstName = "First name must be between 3 and 20 characters.";
      valid = false;
    }
    
    if (!lastName.trim()) {
      newErrors.lastName = "Last name is required.";
      valid = false;
    } else if (lastName.trim().length < 3 || lastName.trim().length > 20) {
      newErrors.lastName = "Last name must be between 3 and 20 characters.";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleSave = () => {
    if (!validateForm()) return;

    setLoading(true);
    const obj = {
      userId,
      firstName: firstName.trim(),
      lastName: lastName.trim(),
    };

    updateCustomerName(obj, headers, dispatch, (response) => {
      if (response.result === 'SUCCESS') {
        toast.current?.show({
          severity: 'success',
          summary: 'Success',
          detail: "Customer name updated successfully.",
        });
        if(page === "details"){
            updateData((prv)=>({...prv,name:firstName + " " + lastName}))
        }else if(page === "user"){
            updateData(prv=>{
                let findIndex = prv.findIndex(item=>item.userId === userId)
                let editObject = prv.find(item=>item.userId === userId)
                editObject.firstName = firstName
                editObject.lastName = lastName
                editObject.userName= firstName + " " + lastName
                prv.splice(findIndex,1,editObject)
                return [...prv]
            })
        }
      
        setNameModal(false);
      } else {
        const error = response.error;
        toast.current?.show({
          severity: error.severity || 'error',
          summary: 'Error',
          detail: error.errorMsg || error.summary || "Something went wrong.",
        });
      }
      setLoading(false);
    });
  };

  return (
    <PR.Dialog
      visible={nameModal}
      dismissableMask
      draggable={false}
      resizable={false}
      header="Edit Name"
      onHide={() => {setNameModal(false);setErrors({ firstName: "", lastName: "" })}}
      className="affiliate-dialog"
      maskClassName="affiliate-dialog-mask"
    >
      <div className="p-fluid">
        
        {/* First Name */}
        <div className="mb-3">
          <p className="mb-2">First Name <span className="validation-required">*</span></p>
          <PR.InputText
            value={firstName}
            keyfilter={/^[a-zA-Z0-9\s]*$/}
            onChange={(e) => {setFirstName(e.target.value);setErrors(prv=>({...prv,firstName:""}))}}
            placeholder="Enter first name"
            className={`w-full ${errors.firstName ? 'p-invalid' : ''}`}
            disabled={loading}
          />
          {errors.firstName && <small className="p-error">{errors.firstName}</small>}
        </div>

        {/* Last Name */}
        <div className="mb-3">
          <p className="mb-2">Last Name <span className="validation-required">*</span></p>
          <PR.InputText
            value={lastName}
            keyfilter={/^[a-zA-Z0-9\s]*$/}
            onChange={(e) => {setLastName(e.target.value);setErrors(prv=>({...prv,lastName:""}))}  }
            placeholder="Enter last name"
            className={`w-full ${errors.lastName ? 'p-invalid' : ''}`}
            disabled={loading}
          />
          {errors.lastName && <small className="p-error">{errors.lastName}</small>}
        </div>

        {/* Action Buttons */}
        <div className="flex justify-content-end gap-2 mt-4">

<PR.Button
  label="Save"
  onClick={()=>handleSave()}
  style={{
    backgroundColor: "#2d3e50", // Dark navy blue
    color: "#fff",
    border: "none"
  }}
/>


        </div>
      </div>
    </PR.Dialog>
  );
}

export default NameModal;
